// @ts-nocheck
/**
 * @param element
 */
export default function getHTMLElementScroll(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}
//# sourceMappingURL=getHTMLElementScroll.js.map